import {
  bindClickEventWithPreventDefault
} from '@/shared'

export function popupOpenLogIn (context) {
  bindClickEventWithPreventDefault(document, '.js-open-log-in', (options) => {
    var script2 = document.createElement('script')
    script2.src = '//connect.facebook.net/en_US/all.js#xfbml=1&version=v2.10&appId=335481643751252'
    script2.type = 'text/javascript'
    document.body.parentNode.appendChild(script2)
    context.modalOpen('log-in', options.e)
    var script = document.createElement('script')
    script.src = '/modules/hifacebookconnect/views/js/facebook-connect-front.js'
    script.type = 'text/javascript'
    document.body.parentNode.appendChild(script)
  })
}



// WEBPACK FOOTER //
// ./src/temporary-code/popup-log-in-open.js